import React from "react";
import { Link, useParams } from "react-router-dom";
// @material-ui/core
// core components
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BackupTable from "components/Table/BackupTable";
import RawBackupTable from "components/Table/RawBackupTable";
import DocumentBackupTable from "components/Table/DocumentBackupTable";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
//custom style
import { makeStyles } from "@mui/styles";
import styles from "assets/jss/material-dashboard-react/components/tabsStyle.js";
const useStyles = makeStyles(styles);
export default function BackupDetail() {

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={12}>
          <MDBox>
            <BasicTabs />
          </MDBox>
        </Grid>
      </Grid>
    </div>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ padding: "0px 22px" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function tabsValue() {
  let tabsValue = Number(localStorage.getItem("tabsValue"));
  if (tabsValue == null || tabsValue == undefined) {
    return 0;
  }
  return tabsValue;
}

function BasicTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(tabsValue);
  const { id } = useParams();
  const handleChange = (event, newValue) => {
    localStorage.setItem("tabsValue", newValue);
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          marginBottom: "30px",
          padding: "10px 20px",
          alignItems: "center"
        }}
      >
        <div style={{flexBasis : "45%", fontSize: "14px"}}>
          <b>Backup file name: </b>
          {id}
        </div>
      </div>
      <Box>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          indicatorColor="secondary"
          className={classes.tabs}
        >
          <Tab label="Postgres Backups" {...a11yProps(0)} />
          <Tab label="Raw Backups" {...a11yProps(1)} />
          <Tab label="Document Backups" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <BackupTable backupId={id} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <RawBackupTable backupId={id} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <DocumentBackupTable backupId={id} />
      </TabPanel>
    </Box>
  );
}
